import React from 'react';
import { MediaMobile, MediaTablet, MediaDesktop } from '../../../MediaWrapper';
import { SeeAddressMobile, SeeAddressDesktop } from '../../common/SeeAddress';
import { AddressProps } from '../../common/types';
import styles from '../style.module.css';

interface Props {
  address: AddressProps;
  showAddressLabel?: boolean;
  styleAddressMobile?: any;
  showH2?: boolean;
  dataValue?: string;
}

export const ShopAddress = ({
  address,
  showAddressLabel,
  styleAddressMobile,
  showH2,
  dataValue,
}: Props) => {
  if (!address.cepAddress) {
    return null;
  }

  const addressLabel = (
    <h2 className="f20 abbey fw2 lh-copy mt16 mb0 mb8-ns mb4-l mb4-m mt18-ns mt40-l mt40-m">
      Endereço
    </h2>
  );

  const h2 = showH2 && (
    <h2 className="f20 abbey fw2 lh-copy ma0 mb12 mb8-ns mb8-l mt24 mt40-m">Endereço</h2>
  );

  return (
    <>
      {h2}
      <MediaMobile>
        <section className="mt16">
          {showAddressLabel && addressLabel}
          <div className="mt0" style={styleAddressMobile}>
            <div className="flex items-center">
              <SeeAddressMobile address={address} addressDataValue={dataValue} />
            </div>
          </div>
        </section>
      </MediaMobile>
      <MediaTablet>
        <section className="mt16">
          {showAddressLabel && addressLabel}
          <div className={styles.seeAddressDesktop}>
            <SeeAddressMobile address={address} addressDataValue={dataValue} />
          </div>
        </section>
      </MediaTablet>
      <MediaDesktop>
        <section className="mt16">
          {showAddressLabel && addressLabel}
          <div className={styles.seeAddressDesktop}>
            <SeeAddressDesktop address={address} addressDataValue={dataValue} />
          </div>
        </section>
      </MediaDesktop>
    </>
  );
};

ShopAddress.defaulProps = {
  showAddressLabel: true,
};
